import { red } from '../colors';
export const errorColor = (mode)=>{
    return mode === 'light' ? {
        main: red[600],
        highContrast: red[700],
        lowContrast: red[100]
    } : {
        main: red[500],
        highContrast: red[100],
        lowContrast: red[800]
    };
};

//# sourceMappingURL=error.js.map